import { AfterViewInit, Component, ElementRef, inject, ViewChild } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { LoginFacade } from './login.facade';
import { Router, RouterModule } from '@angular/router';
import { AuthWrapperComponent } from '../shared/auth-wrapper/auth-wrapper.component';
import { MaterialModule } from '../../material.module';

@Component({
  selector: 'mida-login',
  imports: [ReactiveFormsModule, RouterModule, AuthWrapperComponent, MaterialModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements AfterViewInit {
  private fb = inject(FormBuilder);
  private facade = inject(LoginFacade);

  public loginForm = this.fb.nonNullable.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required]],
    app: ['COLLECT'],
  });

  public passwordState = this.facade.passwordState;
  @ViewChild('passwordRef', { read: ElementRef }) passwordRef!: ElementRef;

  public isLoaderShowing = this.facade.isLoaderShowing;

  public isOtpModalOpen = this.facade.isOtpModalOpen;
  public isOtpVerifying = this.facade.isOtpVerifying;
  public isResendingOtp = this.facade.isResendingOtp;

  public otpDigits: string[] = ['', '', '', '', '', ''];

  ngAfterViewInit(): void {
    setTimeout(() => {
      const emailField = document.getElementById('email') as HTMLInputElement;
      const passwordField = document.getElementById('password') as HTMLInputElement;
      if (emailField) emailField.value = '';
      if (passwordField) passwordField.value = '';
      this.loginForm.reset();
    }, 100);
  }

  public onSubmit(e: Event): void {
    Object.values(this.loginForm.controls).forEach((control) => {
      control.markAsDirty();
      control.markAsTouched();
    });

    if (this.loginForm.invalid) {
      return;
    }
    this.isLoaderShowing.set(true);
    this.facade.login(this.loginForm.value);
  }

  public togglePasswordState(): void {
    this.facade.togglePasswordState(this.passwordRef);
  }

  public onOtpInput(event: any, index: number): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    // Handle paste
    if (event.inputType === 'insertFromPaste' && value.length >= 6) {
      const pastedData = value.substring(0, 6).replace(/\D/g, '');
      for (let i = 0; i < pastedData.length; i++) {
        this.otpDigits[i] = pastedData[i];
        const currentInput = document.getElementById(`otp-input-${i}`) as HTMLInputElement;
        if (currentInput) currentInput.value = pastedData[i];
      }
      const focusIndex = Math.min(pastedData.length, 5);
      const nextInput = document.getElementById(`otp-input-${focusIndex}`) as HTMLInputElement;
      if (nextInput) {
        nextInput.focus();
      }
      return;
    }

    if (value && /^[0-9]$/.test(value)) {
      this.otpDigits[index] = value;
      if (index < 5) {
        const nextInput = document.getElementById(`otp-input-${index + 1}`) as HTMLInputElement;
        if (nextInput) nextInput.focus();
      }
    } else {
      input.value = '';
    }
  }

  public onOtpKeydown(event: KeyboardEvent, index: number): void {
    if (event.key === 'Backspace') {
      if (!this.otpDigits[index] && index > 0) {
        const prevInput = document.getElementById(`otp-input-${index - 1}`) as HTMLInputElement;
        if (prevInput) {
          prevInput.focus();
          this.otpDigits[index - 1] = '';
          prevInput.value = '';
        }
      } else {
        this.otpDigits[index] = '';
      }
    }
  }

  public verifyOtp(): void {
    const code = this.otpDigits.join('');
    if (code.length === 6) {
      this.facade.verifyOtp(code);
    }
  }

  public resendOtp(event: Event): void {
    event.preventDefault();
    this.facade.resendOtp();
    this.otpDigits = ['', '', '', '', '', ''];
    for (let i = 0; i < 6; i++) {
      const input = document.getElementById(`otp-input-${i}`) as HTMLInputElement;
      if (input) input.value = '';
    }
  }
}
